<script setup>
import { computed } from 'vue';
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
} from 'chart.js';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  options: {
    type: Object,
    default: () => ({}),
  },
  height: {
    type: String,
    default: '200px',
  },
});

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
);

const fontFamily =
  '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif';

const defaultOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    intersect: false,
    mode: 'index',
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      titleFont: {
        family: fontFamily,
        size: 12,
        weight: '500',
      },
      bodyFont: {
        family: fontFamily,
        size: 11,
      },
      padding: 12,
      cornerRadius: 8,
      displayColors: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        font: {
          family: fontFamily,
          size: 11,
        },
        color: '#94a3b8',
      },
      border: {
        display: false,
      },
    },
    y: {
      grid: {
        color: 'rgba(148, 163, 184, 0.1)',
        drawBorder: false,
      },
      ticks: {
        font: {
          family: fontFamily,
          size: 11,
        },
        color: '#94a3b8',
        padding: 8,
      },
      border: {
        display: false,
      },
    },
  },
  elements: {
    line: {
      tension: 0.4,
      borderWidth: 1.5,
    },
    point: {
      radius: 0,
      hoverRadius: 4,
      hoverBorderWidth: 1.5,
      hoverBackgroundColor: '#fff',
    },
  },
}));

const mergedOptions = computed(() => ({
  ...defaultOptions.value,
  ...props.options,
}));
</script>

<template>
  <div :style="{ height }">
    <Line :data="data" :options="mergedOptions" />
  </div>
</template>
